import { useEffect, useState } from "react";
import { Moon, Sun } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import useThemeStore from "@/utils/ThemeStore";

export function ModeToggle() {
  const [theme, setTheme] = useState("");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const { updateTheme } = useThemeStore();

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "dark";
    setTheme(savedTheme);
    updateTheme(savedTheme);
  }, []);

  useEffect(() => {
    if (theme) {
      localStorage.setItem("theme", theme);
      document
        .querySelector("html")
        ?.classList.toggle("dark", theme === "dark");
      updateTheme(theme);
    }
  }, [theme, updateTheme]);

  const toggleTheme = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setTimeout(() => {
      setTheme(theme === "dark" ? "light" : "dark");
      setTimeout(() => {
        setIsTransitioning(false);
      }, 200);
    }, 100);
  };

  return (
    <div className="flex items-center justify-center">
      <Button
        onClick={toggleTheme}
        variant="ghost"
        size="icon"
        className="p-2 relative"
        disabled={isTransitioning}
        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      >
        <div
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ease-in-out ${
            theme === "dark" ? "opacity-100" : "opacity-0"
          }`}
        >
          <Moon size={22} className="text-white" />
        </div>
        <div
          className={`absolute inset-0 flex items-center justify-center transition-opacity duration-200 ease-in-out ${
            theme === "dark" ? "opacity-0" : "opacity-100"
          }`}
        >
          <Sun size={22} className="text-gray-700" />
        </div>
      </Button>
    </div>
  );
}
